import Marquee from "react-fast-marquee";

const items = [
  "IT TEAMS",
  "CUSTOMER SUPPORT",
  "INTERNAL OPS",
  "FULL ROOT ACCESS",
  "1-CLICK DEPLOY",
  "COMPLETELY PRIVATE",
];

export const EditorialMarquee = () => (
  <section data-testid="marquee-section" className="border-y border-white/10 bg-[#0A0A0A] py-6">
    <Marquee speed={40} gradient={false} autoFill>
      {items.map((item) => (
        <span key={item} className="mx-12 inline-flex items-center gap-12 font-display text-2xl font-bold uppercase tracking-tight text-neutral-500 md:text-4xl">
          {item}
          <span className="h-2 w-2 bg-primary" />
        </span>
      ))}
    </Marquee>
  </section>
);
